import { createApiCall } from 'lib/base';

const DELETE_STAFF_USER_ASSIGNMENT =
  'DELETE_STAFF_USER_ASSIGNMENT';

const apiCall = createApiCall<{ id: string }>(
  DELETE_STAFF_USER_ASSIGNMENT,
  ({ id }) => ({
    endpoint: `/api/admin/wealth/user-assignments/${id}`,
    method: 'DELETE',
  })
);

export default apiCall;
